var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHoursLate = function SvgHoursLate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 18.974a6.56 6.56 0 0 1-6.557-6.557A6.56 6.56 0 0 1 12 5.86a6.56 6.56 0 0 1 6.557 6.557A6.56 6.56 0 0 1 12 18.974m0-1.295a5.26 5.26 0 0 0 5.269-5.262A5.264 5.264 0 0 0 12 7.148a5.264 5.264 0 0 0-5.269 5.269A5.26 5.26 0 0 0 12 17.679m-.006-8.245a.6.6 0 0 1-.597-.597c0-.324.273-.597.597-.597a.596.596 0 1 1 0 1.193m-2 .609a.596.596 0 1 1-.001-1.192.596.596 0 0 1 .001 1.192m4.005 0a.596.596 0 1 1 0-1.192.596.596 0 0 1 0 1.192m-5.363 1.625a.6.6 0 0 1 0-1.2c.323 0 .596.273.596.603a.604.604 0 0 1-.596.597m6.722 0a.606.606 0 0 1-.603-.597c0-.33.273-.603.603-.603.324 0 .597.273.597.603a.604.604 0 0 1-.597.597m-3.364 4.697c-.559 0-.838-.349-1.06-.825l-1.302-2.774c-.089-.19-.044-.355.077-.444.12-.09.292-.09.45.044l2.33 2.006c.406.33.546.59.546.971 0 .559-.464 1.022-1.041 1.022"
  })));
};
export default SvgHoursLate;